import { SiteAssetsModuleName } from '@wix/thunderbolt-symbols'

export const siteAssetsModules: Array<SiteAssetsModuleName> = [
	'thunderbolt-features',
	'thunderbolt-css',
	'thunderbolt-platform',
	'thunderbolt-site-map',
	'thunderbolt-mobile-app-builder',
]
